import { render, staticRenderFns } from "./instaFeed.vue?vue&type=template&id=a0fadb3a&scoped=true"
import script from "./instaFeed.vue?vue&type=script&lang=js"
export * from "./instaFeed.vue?vue&type=script&lang=js"
import style0 from "./instaFeed.vue?vue&type=style&index=0&id=a0fadb3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fadb3a",
  null
  
)

export default component.exports